import Button from "@material-ui/core/Button";

import { DefaultTheme } from "../../../assets/MuiTheme";
import styled from "../../Utils/styled";

export const ActionButton = styled(Button, {
  TouchRippleProps: {
    style: {
      color: DefaultTheme.palette.primary.main
    }
  }
})(theme => ({
  root: {
    textTransform: "none",
    borderRadius: "50vh",
    paddingTop: 0,
    paddingBottom: 0,
    boxShadow: "none",
    borderColor: theme.palette.primary.main,
    backgroundColor: theme.palette.primary.main,
    borderStyle: "solid",
    fontWeight: 600,
    borderWidth: 1,
    "&:active": {
      boxShadow: "none"
    }
  }
}));



// WEBPACK FOOTER //
// ./src/components/Buttons/ActionButton/ActionButton.tsx